import { motion } from "motion/react";
export function MockupCard({ imageUrl, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={{ y: -10, transition: { duration: 0.3 } }}
      transition={{
        duration: 0.6,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      className="relative group"
    >
      <div className="absolute inset-0 bg-[rgba(253,91,56,0.36)] blur-2xl rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="relative rounded-3xl overflow-hidden bg-[#fd5b38]/10 aspect-[212/428]">
        <img
          src={imageUrl}
          alt="Mockup"
          className="w-full h-full object-cover"
        />
      </div>
    </motion.div>
  );
}
